import {connect} from 'react-redux'

import BaseItemPermissionsContainer from '../shared/BaseItemPermissionsContainer'
import {findRawResourceByAttributeId} from '../../../../../lib/plan_data/userData'
import {defaultRequestItemPermissionIds} from '../../../../../lib/itemPermissionTools'
import {selectAllItemIds} from '../../../../../lib/plan_data/itemSelectors'
import {currentUserConfig} from '../../../../../lib/userTools'

const FirmUserItemPermissionsContainer = props => (
  <BaseItemPermissionsContainer {...props} />
)

const mapStateToProps = (state, ownProps) => {
  const {api} = state
  const userConfig = currentUserConfig(api)

  const requestItemPermissionsInvite = findRawResourceByAttributeId({
    rawResource: api['request-item-permissions-invites'],
    attribute: 'everplan-id',
    id: ownProps.everplanSummary.get('id')
  })

  const firmUserConfig = findRawResourceByAttributeId({
    rawResource: api['firm-user-configs'],
    attribute: 'user-id',
    id: userConfig.get('id')
  })

  return {
    userConfig,
    requestItemPermissionsInvite,
    firmConfig: findRawResourceByAttributeId({
      rawResource: api['firm-configs'],
      attribute: 'firm-id',
      id: ownProps.firmOwnership.get('ownable-id')
    }),
    firmUserConfig,
    ownership: ownProps.firmOwnership,
    allItemIds: selectAllItemIds(state),
    defaultRequestItemPermissionIds: defaultRequestItemPermissionIds({
      anyoneActive: ownProps.anyoneActive,
      firmOwnership: ownProps.firmOwnership,
      firmUserConfig
    }),
    inviteType: 'request-item-permissions-invites'
  }
}

export default connect(mapStateToProps)(FirmUserItemPermissionsContainer)
